module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aqHSj"))).then(() => parcelRequire('1iHdE'));